/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * 살아 있는 로트의 합과 만기 임박 잔액. 원장 정본은 세모 DB(로트·원장)다.
 * @summary 몰 포인트 — 회원별 잔액 목록 (마스터)
 */
export const adminStorefrontsControllerListPointBalancesParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontsControllerListPointBalancesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        members: zod.array(
          zod
            .object({
              memberNo: zod.string().describe("씨마켓 회원/사번"),
              total: zod.number(),
              expiringSoon: zod
                .object({})
                .nullable()
                .describe("만기가 가장 가까운 잔액"),
            })
            .strict(),
        ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 충전(기한)·사용(주문번호)·환불·관리자 차감(사유·주체)·만기 소멸이 줄 단위로 남는다.
 * @summary 몰 포인트 — 한 회원의 원장 이력 (마스터)
 */
export const adminStorefrontsControllerGetPointLedgerParams = zod
  .object({
    id: zod.coerce.string(),
    memberNo: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontsControllerGetPointLedgerResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        entries: zod.array(
          zod
            .object({
              id: zod.string(),
              type: zod.enum(["CHARGE", "SPEND", "REFUND", "DEDUCT", "EXPIRE"]),
              amount: zod
                .number()
                .describe("부호 있는 변동량(충전·환불 +, 사용·차감·만료 -)"),
              balanceAfter: zod.number(),
              orderNo: zod.object({}).nullable(),
              expiresAt: zod
                .object({})
                .nullable()
                .describe("충전 로트의 사용기한 / 만료가 닫은 로트의 기한"),
              reason: zod.object({}).nullable(),
              actor: zod.object({}).nullable().describe("관리자 행위의 주체"),
              createdAt: zod.string(),
            })
            .strict(),
        ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 충전 1건 = 로트 1행. 사용기한은 이 충전분에만 붙는다(비우면 무기한).
 * @summary 몰 포인트 — 충전 (마스터)
 */
export const adminStorefrontsControllerChargePointsParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontsControllerChargePointsBody = zod
  .object({
    memberNo: zod.string(),
    amount: zod.number().describe("충전 포인트(양수 정수)"),
    expiresAt: zod
      .object({})
      .nullish()
      .describe("이 충전분(로트)의 사용기한. 비우면 무기한."),
    reason: zod.object({}).nullish(),
  })
  .strict();

/**
 * 사유 필수. 만기 임박 로트부터(FEFO) 빠지고, 잔액이 모자라면 400 이다.
 * @summary 몰 포인트 — 관리자 차감 (마스터)
 */
export const adminStorefrontsControllerDeductPointsParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontsControllerDeductPointsBody = zod
  .object({
    memberNo: zod.string(),
    amount: zod.number().describe("차감 포인트(양수 정수)"),
    reason: zod
      .string()
      .describe("사유 — 관리자 차감은 사유 없이 성립하지 않는다"),
  })
  .strict();

/**
 * @summary 쇼핑몰 목록 (마스터)
 */
export const adminStorefrontsControllerListResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            id: zod.string(),
            slug: zod.string(),
            name: zod.string(),
            description: zod.string().nullish(),
            isActive: zod.boolean(),
            includeVat: zod
              .boolean()
              .describe("true=부가세 포함가로 표시, false=공급가액으로 표시"),
            supplierCount: zod.number().describe("연결된 활성 업체 수"),
            offeringCount: zod.number().describe("노출 중인 상품 수"),
            createdAt: zod.string(),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 쇼핑몰 생성 (마스터)
 */
export const adminStorefrontsControllerCreateBody = zod
  .object({
    slug: zod.string().describe("피드 경로에 쓰이는 식별자(생성 후 불변)"),
    name: zod.string(),
    description: zod.string().optional(),
  })
  .strict();

/**
 * slug 는 바꿀 수 없다. 가격은 공급사가 정하므로 여기서 다루지 않는다.
 * @summary 쇼핑몰 수정 (마스터)
 */
export const adminStorefrontsControllerUpdateParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontsControllerUpdateBody = zod
  .object({
    includeVat: zod
      .boolean()
      .optional()
      .describe("true=부가세 포함가로 표시, false=공급가액으로 표시"),
    name: zod.string().optional(),
    description: zod.string().optional(),
    isActive: zod.boolean().optional(),
  })
  .strict();

export const adminStorefrontsControllerUpdateResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 연결된 업체 목록 (마스터)
 */
export const adminStorefrontsControllerListSuppliersParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontsControllerListSuppliersResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            id: zod.string(),
            supplierId: zod.string(),
            supplierName: zod.string().nullish(),
            handledItemCount: zod
              .number()
              .describe("이 업체가 취급하는 품목 수"),
            offeringCount: zod.number().describe("이 쇼핑몰에 노출 중인 수"),
            isActive: zod.boolean(),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 업체를 이 쇼핑몰에 연결 (마스터)
 */
export const adminStorefrontsControllerLinkSupplierParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontsControllerLinkSupplierBody = zod
  .object({
    supplierId: zod.string().describe("공급사 ID (suppliers.id)"),
  })
  .strict();

/**
 * 담겨 있던 상품은 삭제하지 않고 비활성으로 내린다. 다시 연결하면 살릴 수 있다.
 * @summary 업체 연결 해제 (마스터)
 */
export const adminStorefrontsControllerUnlinkSupplierParams = zod
  .object({
    id: zod.coerce.string(),
    supplierId: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontsControllerUnlinkSupplierResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        deactivatedOfferings: zod
          .number()
          .describe("연결 해제로 노출이 중지된 상품 수"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 연결된 업체가 취급하는 품목 + 그 업체 단가 + 몰 마진 적용 예상가
 * @summary 담을 후보 품목 (마스터)
 */
export const adminStorefrontsControllerListCandidatesParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontsControllerListCandidatesQueryParams = zod
  .object({
    supplierId: zod.coerce.string(),
    q: zod.coerce.string().optional(),
    offset: zod.unknown().optional(),
    limit: zod.unknown().optional().describe("최대 1000"),
  })
  .strict();

export const adminStorefrontsControllerListCandidatesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              itemId: zod.string(),
              name: zod.string(),
              categoryName: zod.string().nullish(),
              manufacturer: zod.string().nullish(),
              spec1: zod.string().nullish(),
              unit: zod.string().nullish(),
              basePrice: zod
                .number()
                .describe("이 공급사의 일반 공급가(참고용)"),
              isOffered: zod
                .boolean()
                .describe("이 업체 이름으로 이미 담겨 있는가"),
              competitorCount: zod
                .number()
                .describe(
                  "같은 품목을 이미 내고 있는 **다른** 업체 수. 2기부터 한 품목을 여러 곳이 낼 수 있고, 손님은 익명 단가 리스트에서 최저가를 고른다 — 담는다고 남의 줄이 밀려나지 않는다",
                ),
            })
            .strict(),
        ),
        total: zod.number().describe("검색 조건에 맞는 전체 건수"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 노출 상품 목록 (마스터)
 */
export const adminStorefrontsControllerListOfferingsParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontsControllerListOfferingsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            id: zod.string(),
            itemId: zod.string(),
            itemName: zod.string(),
            supplierId: zod.string(),
            supplierName: zod.string().nullish(),
            supplierPrice: zod
              .number()
              .nullish()
              .describe(
                "공급사가 이 몰용으로 입력한 단가. null 이면 아직 안 넣어 노출되지 않는다",
              ),
            basePrice: zod
              .number()
              .nullish()
              .describe("이 공급사의 일반 공급가(참고용, 비교에만 쓴다)"),
            isListed: zod
              .boolean()
              .describe("공급사가 단가를 넣어 실제 노출 중인지"),
            isActive: zod.boolean(),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 이미 담긴 품목이면 공급사·가격을 갈아끼운다 — 한 쇼핑몰에서 한 품목은 한 업체만 판다.
 * @summary 상품 담기 (마스터, 다건)
 */
export const adminStorefrontsControllerAddOfferingsParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontsControllerAddOfferingsBodyItemsMax = 500;

export const adminStorefrontsControllerAddOfferingsBody = zod
  .object({
    items: zod
      .array(
        zod
          .object({
            itemId: zod.string().describe("품목 ID (items_v2_base.id)"),
            supplierId: zod.string().describe("이 품목을 파는 공급사"),
          })
          .strict(),
      )
      .max(adminStorefrontsControllerAddOfferingsBodyItemsMax)
      .describe("한 번에 여러 건을 담는다(최대 500건)"),
  })
  .strict();

/**
 * @summary 노출 상품 수정 (마스터)
 */
export const adminStorefrontsControllerUpdateOfferingParams = zod
  .object({
    id: zod.coerce.string(),
    offeringId: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontsControllerUpdateOfferingBody = zod
  .object({
    supplierId: zod.string().optional().describe("공급사 교체"),
    isActive: zod.boolean().optional(),
    supplierPrice: zod
      .number()
      .nullish()
      .describe(
        "몰 판매가(원). null 이면 단가를 지운다 — 그 줄은 노출에서 빠진다",
      ),
  })
  .strict();

export const adminStorefrontsControllerUpdateOfferingResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 노출 상품 제거 (마스터)
 */
export const adminStorefrontsControllerRemoveOfferingParams = zod
  .object({
    id: zod.coerce.string(),
    offeringId: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontsControllerRemoveOfferingResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 흐름이 어디서 멈췄는지를 보는 목록입니다 — 상태 · 견적 공고 · 검수 세션 · 계약별 계산서 보류를 함께 돌려줍니다.

`contracts[].taxInvoiceHoldReason` 에 값이 있으면 그 계약의 계산서 발행이 막혀 있습니다.
 * @summary 몰 주문 목록 (마스터)
 */
export const adminStorefrontsControllerListOrdersParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontsControllerListOrdersQueryParams = zod
  .object({
    status: zod.coerce.string().optional(),
    offset: zod.unknown().optional(),
    limit: zod.unknown().optional(),
  })
  .strict();

export const adminStorefrontsControllerListOrdersResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        orders: zod.array(
          zod
            .object({
              id: zod.string().describe("주문 id"),
              orderNo: zod.string().describe("주문번호"),
              status: zod
                .string()
                .describe(
                  "주문 상태 — `PLACED` · `QUOTING` · `QUOTE_CLOSED` · `SENT_TO_ERP` · `CONTRACTED` · `SHIPPING` · `DELIVERED` · `INSPECTED` · `SETTLED` · `CANCELED`.",
                ),
              employeeNo: zod
                .string()
                .nullable()
                .describe("주문한 사람의 사번"),
              totalSupply: zod.number().describe("공급가액 합계"),
              totalVat: zod.number().describe("부가세 합계"),
              erpRequisitionNo: zod
                .string()
                .nullable()
                .describe("ERP 가 회신한 구매요구번호"),
              quoteRequestId: zod
                .string()
                .nullable()
                .describe(
                  "이 주문으로 올라간 견적 공고 id. 아직 안 올렸으면 null.",
                ),
              createdAt: zod.string().describe("주문 시각(ISO 8601)"),
              canceledAt: zod
                .string()
                .nullable()
                .describe("취소 시각(ISO 8601). 취소되지 않았으면 null."),
              inspection: zod
                .object({
                  status: zod
                    .string()
                    .describe(
                      "검수 세션 상태 — `OPEN` · `COMPLETED` · `CANCELED`.",
                    ),
                  verificationUrl: zod
                    .string()
                    .nullable()
                    .describe("검수 담당자가 여는 촬영·대조 링크"),
                  reportUrl: zod
                    .string()
                    .nullable()
                    .describe("완료된 검수의 보고서 주소"),
                  matchedCount: zod
                    .number()
                    .nullable()
                    .describe("라벨이 일치한 건수"),
                  unmatchedCount: zod
                    .number()
                    .nullable()
                    .describe(
                      "대조하지 못한 건수. 남아 있어도 검수는 완료될 수 있다.",
                    ),
                  completedAt: zod
                    .string()
                    .nullable()
                    .describe("검수 완료 시각(ISO 8601)"),
                })
                .strict()
                .nullable()
                .describe(
                  "검수 세션. null 이면 대조할 품목이 없어 검수를 열지 않은 주문이다(= 계산서 게이트도 없다).",
                ),
              contracts: zod
                .array(
                  zod
                    .object({
                      id: zod.string().describe("계약 id"),
                      contractNumber: zod.string().describe("계약번호"),
                      supplierId: zod.string().describe("이 계약의 공급사 id"),
                      taxInvoiceHoldReason: zod
                        .string()
                        .nullable()
                        .describe(
                          "계산서 보류 사유. 값이 있으면 **그 계약의 계산서 발행이 막혀 있다**. null 이면 열려 있다.",
                        ),
                    })
                    .strict(),
                )
                .describe("이 주문에 걸린 계약들"),
            })
            .strict(),
        ),
        total: zod.number().describe("필터 조건에 맞는 전체 건수"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 수령검수를 기다리지 않고 그 주문의 계약들에서 계산서 보류를 풉니다. 사유는 5자 이상 필수이며 계약 행에 그대로 남습니다.

계약이 아직 서지 않은 주문이면 `releasedContracts: 0` 입니다(오류가 아닙니다).
 * @summary 계산서 보류 강제 해제 (마스터)
 */
export const adminStorefrontsControllerForceReleaseInspectionParams = zod
  .object({
    id: zod.coerce.string(),
    orderNo: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontsControllerForceReleaseInspectionBodyReasonMin = 5;

export const adminStorefrontsControllerForceReleaseInspectionBody = zod
  .object({
    reason: zod
      .string()
      .min(adminStorefrontsControllerForceReleaseInspectionBodyReasonMin)
      .describe(
        "강제 해제 사유. 계약 행에 그대로 남아 「왜 검수 없이 계산서가 나갔나」에 답한다.",
      ),
  })
  .strict();

/**
 * 송장 입력 없이 주문을 배송완료로 옮기고 검수 세션을 엽니다. 계약 후(CONTRACTED·SHIPPING) 상태에서만 가능하며, 사유 5자 이상 필수.
 * @summary 배송완료 강제 처리 (마스터)
 */
export const adminStorefrontsControllerForceDeliverParams = zod
  .object({
    id: zod.coerce.string(),
    orderNo: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontsControllerForceDeliverBodyReasonMin = 5;

export const adminStorefrontsControllerForceDeliverBody = zod
  .object({
    reason: zod
      .string()
      .min(adminStorefrontsControllerForceDeliverBodyReasonMin)
      .describe(
        "강제 처리 사유. 송장·확정 버튼 없이 상태를 옮긴 근거로 로그에 남는다.",
      ),
  })
  .strict();

/**
 * 배송완료(DELIVERED) 주문을 검수완료(INSPECTED)로 확정합니다. 열린 검수 세션이 있으면 함께 완료 처리되고 계산서 보류가 풀립니다. 사유 5자 이상 필수.
 * @summary 구매확정 강제 처리 (마스터)
 */
export const adminStorefrontsControllerForceConfirmParams = zod
  .object({
    id: zod.coerce.string(),
    orderNo: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontsControllerForceConfirmBodyReasonMin = 5;

export const adminStorefrontsControllerForceConfirmBody = zod
  .object({
    reason: zod
      .string()
      .min(adminStorefrontsControllerForceConfirmBodyReasonMin)
      .describe(
        "강제 처리 사유. 송장·확정 버튼 없이 상태를 옮긴 근거로 로그에 남는다.",
      ),
  })
  .strict();

/**
 * 업체가 취급하는 품목을 조건에 맞춰 한 번에 담는다. dryRun 이 기본이며, 실행하면 배치가 남아 되돌릴 수 있다.
 * @summary 조건으로 일괄 승인 (마스터)
 */
export const adminStorefrontBulkControllerBulkOfferParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontBulkControllerBulkOfferBodyPriceSourceDefault =
  "manual";
export const adminStorefrontBulkControllerBulkOfferBodyMarkupBpDefault = 0;
export const adminStorefrontBulkControllerBulkOfferBodyDryRunDefault = true;

export const adminStorefrontBulkControllerBulkOfferBody = zod
  .object({
    supplierId: zod.string().describe("어느 업체의 품목을 담을지"),
    q: zod.string().optional().describe("품명 부분일치. 비우면 전 품목"),
    categoryIds: zod
      .array(zod.string())
      .optional()
      .describe("카테고리 한정. 대분류를 주면 그 아래 소분류까지 전부 대상"),
    priceMin: zod.number().optional().describe("공급가 하한(원)"),
    priceMax: zod.number().optional().describe("공급가 상한(원)"),
    priceSource: zod
      .enum(["manual", "linked"])
      .default(adminStorefrontBulkControllerBulkOfferBodyPriceSourceDefault)
      .describe(
        "linked 면 승인과 동시에 공급사 단가로 노출된다. manual 이면 공급사가 몰 단가를 적어야 노출된다",
      ),
    markupBp: zod
      .number()
      .default(adminStorefrontBulkControllerBulkOfferBodyMarkupBpDefault)
      .describe("linked 일 때 얹을 가산율(만분율). 0 이면 공급사 단가 그대로"),
    dryRun: zod
      .boolean()
      .default(adminStorefrontBulkControllerBulkOfferBodyDryRunDefault)
      .describe("true 면 건수만 계산하고 아무것도 만들지 않는다"),
  })
  .strict();

export const adminStorefrontBulkControllerBulkOfferResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        dryRun: zod.boolean(),
        candidates: zod.number().describe("조건에 맞는 공급사 품목 수"),
        willCreate: zod.number().describe("새로 담길(담긴) 수"),
        created: zod.number().describe("실제로 만들어진 수(dryRun 이면 0)"),
        alreadyActive: zod.number().describe("이미 담겨 노출 대상인 수"),
        alreadyInactive: zod
          .number()
          .describe("이미 담겼지만 비활성인 수 — 일괄 활성화로 되살릴 수 있다"),
        excluded: zod.number().describe("제외 목록에 걸려 건너뛴 수"),
        batchId: zod.string().nullish().describe("되돌리기의 단위"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 단종·품절처럼 «내리는» 쪽도 대량 작업이 필요하다.
 * @summary 노출 일괄 중지/재개 (마스터)
 */
export const adminStorefrontBulkControllerBulkActiveParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontBulkControllerBulkActiveBodyDryRunDefault = true;

export const adminStorefrontBulkControllerBulkActiveBody = zod
  .object({
    supplierId: zod
      .string()
      .optional()
      .describe("업체 한정. 비우면 이 몰의 전 상품"),
    isActive: zod.boolean().describe("true=노출 재개, false=노출 중지"),
    itemIds: zod.array(zod.string()).optional(),
    dryRun: zod
      .boolean()
      .default(adminStorefrontBulkControllerBulkActiveBodyDryRunDefault),
  })
  .strict();

export const adminStorefrontBulkControllerBulkActiveResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        dryRun: zod.boolean(),
        willChange: zod.number(),
        changed: zod.number(),
        batchId: zod.string().nullish(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 원래는 공급사가 자기 화면에서 하는 일이다. 공급사가 못 하는 동안 마스터가 대신 넣을 수 있게 열어 둔다.
 * @summary 몰 단가 일괄 설정 (마스터 대행)
 */
export const adminStorefrontBulkControllerBulkPricesParams = zod
  .object({
    id: zod.coerce.string(),
    supplierId: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontBulkControllerBulkPricesBodyMarkupBpDefault = 0;
export const adminStorefrontBulkControllerBulkPricesBodyOverwriteDefault = false;
export const adminStorefrontBulkControllerBulkPricesBodyDryRunDefault = true;

export const adminStorefrontBulkControllerBulkPricesBody = zod
  .object({
    mode: zod
      .enum(["copy_base", "link", "unlink", "clear"])
      .describe(
        "copy_base=내 단가 복사 / link=내 단가에 연동(이후 자동 추종) / unlink=지금 값으로 굳히기 / clear=몰 단가 지우기",
      ),
    markupBp: zod
      .number()
      .default(adminStorefrontBulkControllerBulkPricesBodyMarkupBpDefault)
      .describe("가산율(만분율)"),
    overwrite: zod
      .boolean()
      .default(adminStorefrontBulkControllerBulkPricesBodyOverwriteDefault)
      .describe("이미 값이 있는 줄도 덮어쓸지. 기본은 빈 칸만 채운다"),
    itemIds: zod
      .array(zod.string())
      .optional()
      .describe("지정하면 그 품목만. 비우면 이 몰의 내 전 품목"),
    dryRun: zod
      .boolean()
      .default(adminStorefrontBulkControllerBulkPricesBodyDryRunDefault),
  })
  .strict();

export const adminStorefrontBulkControllerBulkPricesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        dryRun: zod.boolean(),
        mode: zod.enum(["copy_base", "link", "unlink", "clear"]),
        targets: zod.number().describe("조건에 걸린 줄 수"),
        willChange: zod.number().describe("값이 바뀔(바뀐) 줄 수"),
        changed: zod.number().describe("실제로 바뀐 줄 수(dryRun 이면 0)"),
        skipped: zod.number().describe("조건에 안 맞아 건너뛴 줄 수"),
        noBasePrice: zod
          .number()
          .describe("공급사 단가가 없어 복사할 값이 없는 줄 수"),
        samples: zod
          .array(
            zod
              .object({
                name: zod.string(),
                oldPrice: zod.number().nullish(),
                newPrice: zod.number().nullish(),
                ratio: zod
                  .number()
                  .describe("변동 배수. 1 에서 멀수록 확인이 필요하다"),
              })
              .strict(),
          )
          .describe(
            "변동폭이 큰 순 최대 20건. 2만 건에서 오타를 찾는 유일한 창",
          ),
        batchId: zod.string().nullish(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 일괄 작업 이력 (마스터)
 */
export const adminStorefrontBulkControllerListBatchesParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontBulkControllerListBatchesQueryParams = zod
  .object({
    offset: zod.unknown().optional(),
    limit: zod.unknown().optional(),
  })
  .strict();

export const adminStorefrontBulkControllerListBatchesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string(),
              action: zod.enum([
                "bulk_offer",
                "bulk_price",
                "bulk_active",
                "rule_apply",
              ]),
              supplierId: zod.string().nullish(),
              supplierName: zod.string().nullish(),
              affected: zod.number().describe("바뀐 줄 수"),
              params: zod.object({}).nullish(),
              result: zod.object({}).nullish(),
              undoneAt: zod.string().nullish(),
              undoneCount: zod.number().nullish(),
              createdAt: zod.string(),
              canUndo: zod.boolean().describe("되돌릴 수 있는 작업인지"),
            })
            .strict(),
        ),
        total: zod.number(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 그 배치가 만든 것 중 **그 뒤로 아무도 손대지 않은 줄만** 되돌린다. 공급사가 단가를 적어 넣은 줄은 그대로 둔다.
 * @summary 일괄 작업 되돌리기 (마스터)
 */
export const adminStorefrontBulkControllerUndoBatchParams = zod
  .object({
    id: zod.coerce.string(),
    batchId: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontBulkControllerUndoBatchResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        batchId: zod.string(),
        undone: zod.number().describe("되돌린 줄 수"),
        skipped: zod
          .number()
          .describe("그 뒤에 공급사가 손대서 그대로 둔 줄 수"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 상시 승인 규칙 목록 (마스터)
 */
export const adminStorefrontBulkControllerListRulesParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontBulkControllerListRulesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            id: zod.string(),
            supplierId: zod.string(),
            supplierName: zod.string().nullish(),
            scope: zod.enum(["all", "category"]),
            categoryIds: zod.array(zod.string()).nullish(),
            q: zod.string().nullish(),
            priceMin: zod.number().nullish(),
            priceMax: zod.number().nullish(),
            autoPriceSource: zod.enum(["none", "linked"]),
            autoMarkupBp: zod.number(),
            isActive: zod.boolean(),
            lastAppliedAt: zod.string().nullish(),
            lastAppliedCount: zod.number().nullish(),
            createdAt: zod.string(),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 조건을 저장해 두면 나중에 등록되는 품목도 자동으로 편입된다. 일괄 승인만으로는 «새 상품이 몰에 안 뜬다» 가 반복된다.
 * @summary 상시 승인 규칙 생성 (마스터)
 */
export const adminStorefrontBulkControllerCreateRuleParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontBulkControllerCreateRuleBodyScopeDefault = "all";
export const adminStorefrontBulkControllerCreateRuleBodyAutoPriceSourceDefault =
  "none";
export const adminStorefrontBulkControllerCreateRuleBodyAutoMarkupBpDefault = 0;

export const adminStorefrontBulkControllerCreateRuleBody = zod
  .object({
    supplierId: zod.string(),
    scope: zod
      .enum(["all", "category"])
      .default(adminStorefrontBulkControllerCreateRuleBodyScopeDefault),
    categoryIds: zod.array(zod.string()).optional(),
    q: zod.string().optional(),
    priceMin: zod.number().optional(),
    priceMax: zod.number().optional(),
    autoPriceSource: zod
      .enum(["none", "linked"])
      .default(
        adminStorefrontBulkControllerCreateRuleBodyAutoPriceSourceDefault,
      )
      .describe("linked 면 규칙이 넣은 품목이 공급사 단가로 곧바로 노출된다"),
    autoMarkupBp: zod
      .number()
      .default(adminStorefrontBulkControllerCreateRuleBodyAutoMarkupBpDefault),
  })
  .strict();

/**
 * @summary 상시 승인 규칙 수정 (마스터)
 */
export const adminStorefrontBulkControllerUpdateRuleParams = zod
  .object({
    id: zod.coerce.string(),
    ruleId: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontBulkControllerUpdateRuleBody = zod
  .object({
    isActive: zod.boolean().optional(),
    scope: zod.enum(["all", "category"]).optional(),
    categoryIds: zod.array(zod.string()).optional(),
    q: zod.string().optional(),
    autoPriceSource: zod.enum(["none", "linked"]).optional(),
    autoMarkupBp: zod.number().optional(),
  })
  .strict();

export const adminStorefrontBulkControllerUpdateRuleResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 상시 승인 규칙 삭제 (마스터)
 */
export const adminStorefrontBulkControllerRemoveRuleParams = zod
  .object({
    id: zod.coerce.string(),
    ruleId: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontBulkControllerRemoveRuleResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 크론을 기다리지 않고 바로 훑는다.
 * @summary 상시 승인 규칙 지금 적용 (마스터)
 */
export const adminStorefrontBulkControllerApplyRulesParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontBulkControllerApplyRulesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        rules: zod.number().describe("적용한 규칙 수"),
        created: zod.number().describe("새로 담긴 품목 수"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 여기 있는 품목은 규칙·일괄 승인이 다시 담지 않는다.
 * @summary 제외 목록 (마스터)
 */
export const adminStorefrontBulkControllerListExclusionsParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontBulkControllerListExclusionsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            id: zod.string(),
            itemId: zod.string(),
            itemName: zod.string().nullish(),
            supplierId: zod.string().nullish(),
            reason: zod.string().nullish(),
            createdAt: zod.string(),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 제외 목록에 추가 (마스터)
 */
export const adminStorefrontBulkControllerAddExclusionParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontBulkControllerAddExclusionBody = zod
  .object({
    itemId: zod.string(),
    supplierId: zod
      .string()
      .optional()
      .describe("비우면 이 몰 전체에서 제외(어느 업체가 내든 안 담긴다)"),
    reason: zod.string().optional(),
  })
  .strict();

/**
 * @summary 제외 목록에서 제거 (마스터)
 */
export const adminStorefrontBulkControllerRemoveExclusionParams = zod
  .object({
    id: zod.coerce.string(),
    exclusionId: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontBulkControllerRemoveExclusionResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 공급사가 «이 품목도 올리고 싶다» 를 보낸 목록.
 * @summary 공급사 승인 요청 큐 (마스터)
 */
export const adminStorefrontBulkControllerListRequestsParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontBulkControllerListRequestsQueryParams = zod
  .object({
    status: zod.coerce.string().optional(),
    offset: zod.unknown().optional(),
    limit: zod.unknown().optional(),
  })
  .strict();

export const adminStorefrontBulkControllerListRequestsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string(),
              storefrontId: zod.string(),
              supplierId: zod.string(),
              supplierName: zod.string().nullish(),
              itemId: zod.string(),
              itemName: zod.string().nullish(),
              basePrice: zod.number().nullish(),
              note: zod.string().nullish(),
              status: zod.enum(["pending", "approved", "rejected"]),
              decisionNote: zod.string().nullish(),
              createdAt: zod.string(),
            })
            .strict(),
        ),
        total: zod.number(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 승인하면 그 자리에서 offering 이 생겨 공급사가 단가를 넣을 수 있다.
 * @summary 승인 요청 처리 (마스터)
 */
export const adminStorefrontBulkControllerDecideRequestParams = zod
  .object({
    id: zod.coerce.string(),
    requestId: zod.coerce.string(),
  })
  .strict();

export const adminStorefrontBulkControllerDecideRequestBodyPriceSourceDefault =
  "manual";

export const adminStorefrontBulkControllerDecideRequestBody = zod
  .object({
    status: zod.enum(["approved", "rejected"]),
    priceSource: zod
      .enum(["manual", "linked"])
      .default(adminStorefrontBulkControllerDecideRequestBodyPriceSourceDefault)
      .describe("승인할 때 만들 줄의 가격 출처"),
    decisionNote: zod.string().optional(),
  })
  .strict();

export const adminStorefrontBulkControllerDecideRequestResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();
